<template>
  <div>
    <!-- Botón para abrir la ventana modal -->
    <v-btn color="primary" @click="openModal">
      Pasos para utilizar Google Earth
    </v-btn>
 <!-- Imagen debajo del botón -->
 <v-img 
      src="@/assets/globot.png"
      @click="getContents"
      class="grey lighten-2"
      width="100%"
    ></v-img>
    <!-- Ventana Modal -->
    <v-dialog v-model="isModalOpen" persistent max-width="800px">
      <v-card>
        <v-card-title>
          Pasos para utilizar Google Earth
        </v-card-title>
        <v-card-text>
          <v-carousel>
            <!-- Ítem del carrusel para el paso 1 -->
            <v-carousel-item>
              <img src="@/assets/p1.png" alt="Paso 1" style="max-width: 100%; height: auto;">
              <div class="text-h6">1er Paso: Dar click en la imagen</div>
            </v-carousel-item>
            <!-- Ítem del carrusel para el paso 2 -->
            <v-carousel-item>
              <img src="@/assets/p2.png" alt="Paso 2" style="max-width: 100%; height: auto;">
              <div class="text-h6">2do Paso: Colocar el nombre de lugar a visitar</div>
            </v-carousel-item>
            <!-- Puedes seguir agregando más ítems aquí -->
              <!-- Ítem del carrusel para el paso 3 -->
              <v-carousel-item>
              <img src="@/assets/p3.png" alt="Paso 3" style="max-width: 100%; height: auto;">
              <div class="text-h6">3er Paso: Dar click en el icono</div>
            </v-carousel-item>
              <!-- Ítem del carrusel para el paso 4 -->
              <v-carousel-item>
              <img src="@/assets/p4.png" alt="Paso 4" style="max-width: 100%; height: auto;">
              <div class="text-h6">4to Paso: Seleccionar cualquier circulo azul para visualizar</div>
            </v-carousel-item>
        <!-- Ítem del carrusel para el paso 5 -->
         <v-carousel-item>
              <img src="@/assets/p5.png" alt="Paso 5" style="max-width: 100%; height: auto;">
              <div class="text-h6">5to Paso: Visualiza el lugar seleccionado</div>
            </v-carousel-item>
          </v-carousel>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="closeModal">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isModalOpen: false,
    };
  },
  methods: {
    openModal() {
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },
    getContents() {
      const url = "https://earth.google.com/web/";
      window.open(url, "_blank");
    }
  }
}
</script>

<style scoped>
/* Aquí puedes agregar estilos específicos para el botón o la ventana modal */
.v-btn {
  margin: 10px 0;
}
.v-carousel .v-carousel-item {
  min-height: 400px; /* Adjust this value as needed */
}
</style>
